import { ReactNode } from 'react';

import { Text, useColorModeValue } from '@ecoinvent/ui';

type TooltipHeaderProps = {
  children: ReactNode;
};

/*
 * This component codifies some styling for the "header" of a tooltip's content
 * when chakra's <Tooltip /> is used with rich content (via label prop).
 *
 * Used in two places at the time of writing this comment (in the v4 flows view),
 * however, likely a more widespread pattern, as well as potentially an adaptation
 * of eco UI.
 *
 * Also, see TooltipBody.tsx
 */
const TooltipHeader = ({ children }: TooltipHeaderProps) => (
  <Text fontWeight="bold" color={useColorModeValue('white', undefined)}>
    {children}
  </Text>
);

export default TooltipHeader;
